export default __webpack_public_path__ + "static/1-8588713ff152700cdaebdde27be0917b.jpeg";